import { render, staticRenderFns } from "./EmailNotificationAddForm.vue?vue&type=template&id=1b4a1d51&scoped=true&"
import script from "./EmailNotificationAddForm.vue?vue&type=script&lang=js&"
export * from "./EmailNotificationAddForm.vue?vue&type=script&lang=js&"
import style0 from "./EmailNotificationAddForm.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./EmailNotificationAddForm.vue?vue&type=style&index=1&id=1b4a1d51&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4a1d51",
  null
  
)

export default component.exports